import {
	UFOExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
	untilAll,
} from '@atlassian/ufo';

export const GlobalIssueCreateFromTopNav = new UFOExperience('global-issue-create-from-top-nav', {
	type: ExperienceTypes.Operation,
	performanceType: ExperiencePerformanceTypes.Custom,
	until: untilAll([{ category: 'global-issue-create.create-issue' }]),
});

export const projectsMenuDropdownRecommendationSelector = new UFOExperience(
	'projects-menu-dropdown.recommendation-selector',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const projectsMenuDropdownLoadJpdRecommendation = new UFOExperience(
	'projects-menu-dropdown.load-jpd-recommendation',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
